import { createDialogOptionEventListener } from '../../Inamove/Components/Dialog/DialogOption'
import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Level, { levelActionCreator, LevelActionsAction } from '../../Inamove/Components/Level'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer, {
    createInventoryItemActionListener,
    InventoryActionType,
} from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

const levelId = 'level6'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const PutzfrauKloPapVideo = new Video(Config.CINEMATIC_PATH + 'V12' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(PutzfrauKloPapVideo)
    const PutzzeugVideo = new Video(Config.CINEMATIC_PATH + 'V13' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(PutzzeugVideo)

    const wcOpenAudio = AudioController.add(Config.GAME_SCENE_PATH + 'K31A/audio/wc-open' + Config.AUDIO_FILE_EXT)
    const wcCloseAudio = AudioController.add(Config.GAME_SCENE_PATH + 'K31A/audio/wc-close' + Config.AUDIO_FILE_EXT)
    const nachPutzfrauAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K36/audio/nachPutzfrau' + Config.AUDIO_FILE_EXT
    )

    const TerminalImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K37/K37-terminal.png')
    LoadingController.addToQueue(TerminalImage)
    level.gameScenes.K37.addImage(TerminalImage)

    // some items are takeable after the player talked to the Putzfrau
    // so we have to show place holders that are interactable objects and switch the out once
    // the player does the required action

    // Seife
    const SeifeImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K30/K30-Seife.png')
    LoadingController.addToQueue(SeifeImage)
    level.gameScenes.K30.addImage(SeifeImage)
    // Hide Seife Takeable in Kulisse K30
    level.gameScenes.K30.hideTakeableObject('seife1')

    // Klopapier
    const KlopapierImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K31A/K31A-klopapier.png')
    LoadingController.addToQueue(KlopapierImage)
    level.gameScenes.K31A.addImage(KlopapierImage)
    // Hide Klopapier takeable
    level.gameScenes.K31A.hideTakeableObject('klopapier1')

    // Klodeckel can be opened & closed
    // when it is open the user can take water
    level.gameScenes.K31A.hideInteractableObject('klodeckel1')
    const KlodeckelOpenImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K31A/K31A-Klodeckel.png')
    LoadingController.addToQueue(KlodeckelOpenImage)
    level.gameScenes.K31A.addImage(KlodeckelOpenImage)
    KlodeckelOpenImage.hide()

    // wasser
    level.gameScenes.K31A.hideTakeableObject('wasser1')
    level.gameScenes.K31A.hideInteractableObject('wasser')
    let canTakeWasser = false

    createInteractableObjectListener('klodeckel', () => {
        // öffne klodeckel
        AudioController.play(wcOpenAudio)
        KlodeckelOpenImage.show()
        level.gameScenes.K31A.hideInteractableObject('klodeckel')
        level.gameScenes.K31A.showInteractableObject('klodeckel1')
        canTakeWasser
            ? level.gameScenes.K31A.showTakeableObject('wasser1')
            : level.gameScenes.K31A.showInteractableObject('wasser')
    })

    createInteractableObjectListener('klodeckel1', () => {
        // schließe klodeckel
        AudioController.play(wcCloseAudio)
        KlodeckelOpenImage.hide()
        level.gameScenes.K31A.hideInteractableObject('klodeckel1')
        level.gameScenes.K31A.showInteractableObject('klodeckel')
        canTakeWasser
            ? level.gameScenes.K31A.hideTakeableObject('wasser1')
            : level.gameScenes.K31A.hideInteractableObject('wasser')
    })

    // putzfrau
    let toiPapGiven = false
    createInteractableObjectListener('putzfrau', async (interactableObject) => {
        switch (interactableObject.interactData?.action) {
            case 'K36-Dialog': {
                // first Dialog
                level.stopGame()
                await level.startDialog('D3')
                level.startGame()

                AudioController.play(nachPutzfrauAudio)

                // Klopapier is ready for the taking
                level.gameScenes.K31A.hideInteractableObject('klopapier')
                level.gameScenes.K31A.removeImage(KlopapierImage)
                level.gameScenes.K31A.showTakeableObject('klopapier1')

                canTakeWasser = true

                break
            }
            case 'D4': {
                level.stopGame()

                if (!toiPapGiven) {
                    AudioController.setMute(true)
                    CinematicContainer.setVideo(PutzfrauKloPapVideo)
                    GameSceneContainer.hide()
                    CinematicContainer.show()
                    await CinematicContainer.play()
                    AudioController.setMute(false)
                    CinematicContainer.hide()
                    toiPapGiven = true
                }

                await level.startDialog('D4')
                GameSceneContainer.show()
                level.startGame()

                break
            }
        }
    })

    createInventoryItemActionListener('I22', InventoryActionType.added, () => {
        level.gameScenes.K36.interactableObjects['putzfrau'].setInteractionHandler('D4')
    })

    createDialogOptionEventListener('putzzeugHerstellen', () => {
        level.gameScenes.K30.removeImage(SeifeImage)
        level.gameScenes.K30.showTakeableObject('seife1')
    })

    createInventoryItemActionListener(
        'I36',
        InventoryActionType.added,
        async () => {
            CinematicContainer.setVideo(PutzzeugVideo)
            GameSceneContainer.hide()
            CinematicContainer.show()
            level.stopGame(true)
            await CinematicContainer.play()
            CinematicContainer.hide()
            dispatch(levelActionCreator(level, LevelActionsAction.stop))
        },
        true
    )

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                resolve()
                level.destroy()
            }
        })
    })
}
